import './../../../../../assets/js/powerreviews.ui';
import './userReviews.scss';
import PowerReviews from '../../shared/PowerReviews';
import $ from 'jquery';
import { getNewPageTile } from './../ModelNav/pageTile';
import { scrollToSection } from './../ModelNav/modelHashNavigation';

export default function () {
    const reviewSnippet = 'pr-reviewsnippet';
    const reviewDisplay = 'pr-reviewdisplay';
    const legalease = 'pr-legalease';
    const $reviewSnippet = $('#' + reviewSnippet);
    const $reviewDisplay = $('#' + reviewDisplay);
    const $legalease = $('.' + legalease);
    const $userReviewsSection = $('#user-reviews .model-section__body');
    const s = s_gi(s_account);

    if ($reviewDisplay.length) {
        const configPowerReviews = $.extend({
            prReviewSnippet: reviewSnippet,
            prReviewDisplay: reviewDisplay,
            prOnReadReviewsClick: function () {
                trackSCReadReviewLink();
                if (window.history && configPowerReviews.prReadReviewUrl.indexOf(window.location.pathname) === -1) {
                    window.history.pushState({'hrefState': configPowerReviews.prReadReviewUrl}, getNewPageTile(), configPowerReviews.prReadReviewUrl);
                }
                $legalease.hide();
                scrollAndOpenSection();
            },
            prOnWriteReviewClick: function () {
                if (window.history && configPowerReviews.prWriteReviewUrl.indexOf(window.location.pathname) === -1) {
                    window.history.pushState({'hrefState': configPowerReviews.prWriteReviewUrl}, getNewPageTile(), configPowerReviews.prWriteReviewUrl);
                }
                $legalease.show();
                scrollAndOpenSection();

            },
            prOnSubmit: function () {
                trackSCReviewSubmittedEvent();
                scrollToSection("#user-reviews");
            }
        }, $reviewDisplay.data());


        const trackSCReadReviewLink = function() {
            s.prop48 = s.eVar48 = s.pageName + ' | ' + 'user_reviews_view-top';
            s.tl();
        };

        const trackSCReviewSubmittedEvent = function() {
            s.linkTrackVars='prop48,eVar48,prop58,eVar58,prop72,eVar72,events';
            s.linkTrackEvents=s.events='event34';
            s.prop48=s.eVar48=s.pageName+' | '+'user_reviews_submit-bottom';
            s.tl(this,'o','user_reviews');
        };

        const powerReviews = new PowerReviews(configPowerReviews);

        $(window).bind('popstate', function (event) {
            if (event.originalEvent.state && event.originalEvent.state.hrefState) {
                const path = event.originalEvent.state.hrefState;
                if (configPowerReviews.prWriteReviewUrl.indexOf(path) !== -1) {
                    powerReviews.renderWriteReview();
                    $legalease.show();
                } else {
                    powerReviews.renderReadReviews();
                    $legalease.hide();
                }
            }
        });

        const renderReadReviewsOrWriteReview = function () {
            if (configPowerReviews.prDisplayReadReview) {
                powerReviews.renderReadReviews();
            } else {
                powerReviews.renderWriteReview();
            }
        };

        const scrollAndOpenSection = () => {
            scrollToSection("#user-reviews");
            $userReviewsSection.collapse('show');
        };

        if ($reviewSnippet.length) {
            const domSubtreeModifiedHandler = function () {
                $reviewSnippet.unbind('DOMSubtreeModified', domSubtreeModifiedHandler);
                renderReadReviewsOrWriteReview();
            };
            $reviewSnippet.bind('DOMSubtreeModified', domSubtreeModifiedHandler);
            powerReviews.renderReviewSnippet();
        } else {
            renderReadReviewsOrWriteReview();
        }

    }

    /**
     * COPR-4555
     * watching for any modification within "user-reviews" section because PowerReviews's callback doesn't work
     */

    if(document.getElementById('user-reviews')) {
        new MutationObserver(() => {
            var s = s_gi(s_account);
            s.linkTrackVars='prop48,eVar48,prop58,eVar58,prop72,eVar72';
            s.linkTrackEvents = s.events = "";

            // Track read complete view
            $('#pr-review-snapshot section.pr-review-snapshot-faceoff button').each(function(i, item) {
                $(item).off('click').click(function() {
                    s.prop48 = s.eVar48 = s.pageName + ' | ' + 'user_reviews_read-bottom';
                    s.tl(this,'o','user_reviews');
                });
            });

            // Track write review from top
            $('#pr-reviewsnippet > div > section > div > div.pr-snippet-stars-reco-stars > div > div.pr-snippet-read-and-write > a.pr-snippet-write-review-link').off('click').click(function() {
                s.prop48 = s.eVar48 = s.pageName + ' | ' + 'user_reviews_write-top';
                s.tl(this,'o','user_reviews');
            });

            // Track review from the bottom
            $('#pr-review-snapshot > header > section.pr-review-snapshot-snippets > div > div.pr-snippet-stars-reco-stars > div > div.pr-snippet-read-and-write > a.pr-snippet-write-review-link').off('click').click(function() {
                s.prop48 = s.eVar48 = s.pageName + ' | ' + 'user_reviews_write-bottom';
                s.tl(this,'o','user_reviews');
            });

            // Track more details button
            $('#pr-review-display > article > section.pr-rd-content-block.pr-accordion.pr-accordion-collapsed > button.pr-accordion-btn').off('click').on('click', function(item) {

                // var aria_expanded = $(item).attr('aria-expanded');
                s.prop48 = s.eVar48 = s.pageName + ' | ' + 'user_reviews_details-bottom';
                s.tl(this,'o','user_reviews');
                // return false;

            });

            // Track pagination
            $('#pr-review-display > footer > div > aside > button').off('click').click(function() {
                $('#pr-review-display > footer > div > p > span.pr-rd-bold').each(function(i, item) {
                    s.prop48 = s.eVar48 = s.pageName + ' | ' + 'user_reviews_' + $(item).html().split('-').join('_');
                    s.tl(this,'o','user_reviews');
                });

            });

            if (window.location.href.indexOf('#Price') > 0)
                window.scrollTo( 0, $('#Price').offset().top - $("#model-nav>div.model-nav__additional-info").height());

        }).observe(document.getElementById('user-reviews'), { attributes: true, childList: true, subtree: true });
    }


    /**
     * end COPR-4555
     */
};



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/UserReviews/index.js